// CORE
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import axios from "axios";

// COMPONENTS
import Header from "../../components/UI/Header/Header";
import OrthognathicSurgery from "./Form/0";
import Vestibuloplasty from "./Form/1";
import IntravenousBisphosphonate from "./Form/2";
import OralBisphosphonate from "./Form/3";
import FacialFractures from "./Form/4";
import DentalImplant from "./Form/5";
import BoneGrafting from "./Form/6";
import RamusTuberosityBoneGrafting from "./Form/7";
import OralMaxillofacial from "./Form/8";
import EndosseousImplants from "./Form/9";
import ThirdMolarExatraction from "./Form/10";
import { backendBaseUri } from "../../uri";

import filesaver from "file-saver";
import b64toblob from "b64-to-blob";

// STYLES
import classes from "./layout.css";

class FormLayout extends Component {
    state = {
        disableDraftBtn: true,
        disableCompleteBtn: true,
    };

    componentDidMount() {
        this.checkEnableCompleteBtn();
    }

    addToForm(name, value, id) {
        const { consentFormDisplay } = this.props;
        if (id) {
            consentFormDisplay[name][id] = value;
        } else {
            consentFormDisplay[name] = value;
        }
        this.checkEnableDraftsBtn();
        this.checkEnableCompleteBtn();
    }

    checkEnableDraftsBtn() {
        const { consentFormDisplay } = this.props;
        if (consentFormDisplay.patientName.length > 0 && consentFormDisplay.currentDate) {
            this.setState({
                disableDraftBtn: false,
            });
        } else {
            return;
        }
    }

    checkEnableCompleteBtn() {
        const { consentFormDisplay } = this.props;

        if (
            consentFormDisplay.patientName &&
            consentFormDisplay.currentDate &&
            consentFormDisplay.patientSignature &&
            consentFormDisplay.doctorSignature &&
            consentFormDisplay.witnessSignature &&
            consentFormDisplay.patientSignDate &&
            consentFormDisplay.doctorSignDate &&
            consentFormDisplay.witnessSignDate
        ) {
            this.setState({
                disableCompleteBtn: false,
            });
        } else if (consentFormDisplay.formId === 9 || consentFormDisplay.formId === 10) {
            if (
                consentFormDisplay.patientName &&
                consentFormDisplay.currentDate &&
                consentFormDisplay.patientSignature &&
                consentFormDisplay.witnessSignature &&
                consentFormDisplay.patientSignDate &&
                consentFormDisplay.witnessSignDate
            ) {
                this.setState({
                    disableCompleteBtn: false,
                });
            } else {
                return;
            }
        } else {
            return;
        }
    }

    onSaveForm() {
        const {
            formId,
            formName,
            currentDate,
            patientName,
            patientSignature,
            doctorSignature,
            witnessSignature,
        } = this.props.consentFormDisplay;

        let pdfName = `${currentDate}_${patientName}_${formName}`;

        let source = document.getElementById(`${formId}`);
        let htmlstring = source.outerHTML;
        let data = {
            html: htmlstring,
            name: pdfName,
            patientSignature,
            doctorSignature,
            witnessSignature,
        };

        axios
            .post(`${backendBaseUri}/converttopdf`, data, {
                headers: {
                    "x-auth": localStorage.getItem("token"),
                },
            })
            .then((res) => {
                let file = res.data.pdf;
                let blob = b64toblob(file, "application/pdf");
                filesaver.saveAs(blob, `${pdfName}.pdf`);
            });
        this.onSaveDraft();
    }

    onSaveDraft() {
        const { consentFormDisplay } = this.props;
        if (consentFormDisplay.draftedFormName) {
            axios
                .put(`${backendBaseUri}/drafts/${consentFormDisplay._id}`, consentFormDisplay, {
                    headers: {
                        "x-auth": localStorage.getItem("token"),
                    },
                })
                .then((res) => {
                    this.props.saveDraft(res.data);
                    this.props.history.push("/drafts");
                })
                .catch((err) => {
                    console.log(err);
                });
        } else {
            consentFormDisplay._id = null;

            consentFormDisplay["draftedFormName"] = `${consentFormDisplay.currentDate}_${
                consentFormDisplay.patientName
            }_${consentFormDisplay.formName}`;
            axios
                .post(`${backendBaseUri}/drafts`, consentFormDisplay, {
                    headers: {
                        "x-auth": localStorage.getItem("token"),
                    },
                })
                .then((res) => {
                    this.props.saveDraft(res.data);
                    this.props.history.push("/drafts");
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }

    displayForm() {
        const form = this.props.consentFormDisplay;
        const { formId } = this.props.consentFormDisplay;

        switch (formId) {
            case 0:
                return (
                    <OrthognathicSurgery addToForm={this.addToForm.bind(this)} consentForm={form} />
                );
            case 1:
                return <Vestibuloplasty addToForm={this.addToForm.bind(this)} consentForm={form} />;
            case 2:
                return (
                    <IntravenousBisphosphonate
                        addToForm={this.addToForm.bind(this)}
                        consentForm={form}
                    />
                );
            case 3:
                return (
                    <OralBisphosphonate addToForm={this.addToForm.bind(this)} consentForm={form} />
                );
            case 4:
                return <FacialFractures addToForm={this.addToForm.bind(this)} consentForm={form} />;
            case 5:
                return <DentalImplant addToForm={this.addToForm.bind(this)} consentForm={form} />;
            case 6:
                return <BoneGrafting addToForm={this.addToForm.bind(this)} consentForm={form} />;
            case 7:
                return (
                    <RamusTuberosityBoneGrafting
                        addToForm={this.addToForm.bind(this)}
                        consentForm={form}
                    />
                );
            case 8:
                return (
                    <OralMaxillofacial addToForm={this.addToForm.bind(this)} consentForm={form} />
                );
            case 9:
                return (
                    <EndosseousImplants addToForm={this.addToForm.bind(this)} consentForm={form} />
                );
            case 10:
                return (
                    <ThirdMolarExatraction
                        addToForm={this.addToForm.bind(this)}
                        consentForm={form}
                    />
                );
            default:
                return <div />;
        }
    }

    render() {
        const { disableCompleteBtn, disableDraftBtn } = this.state;

        return (
            <div className={classes.MainContainer}>
                <header>
                    <Header />
                </header>
                <div className={classes.FormBorder}>{this.displayForm()}</div>
                <div className={classes.ButtonSection}>
                    <button>
                        <Link to="/consents">Cancel</Link>
                    </button>
                    <button disabled={disableDraftBtn} onClick={() => this.onSaveDraft()}>
                        Save
                    </button>
                    <button disabled={disableCompleteBtn} onClick={() => this.onSaveForm()}>
                        Export
                    </button>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        consentForms: state.formBuilder.consentForms,
        consentFormDisplay: state.formBuilder.consentFormDisplay,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        saveForm: (form) => dispatch(actions.saveForm(form)),
        saveDraft: (form) => dispatch(actions.saveDraft(form)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(FormLayout);



// WEBPACK FOOTER //
// ./src/containers/FormLayout/FormLayout.js